export enum ActionButtonVariant {
  Secondary,
  SecondaryOutlined,
}
